import React, { useContext, useEffect } from 'react'
import StylesContext from '../UtilsComponents/SytlesContextViewSurvey';
import CreateIcon from '@mui/icons-material/Create';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from '@tanstack/react-query';
import useAxiosPrivate from '../../../CustomHooks/useAxiosPrivate';
import useAuth from '../../../CustomHooks/useAuth';
import LoadingDots from '../CreateSurveyComponents/MainSurveyComponensts/LoadingDots';

export const SurveyTitles = ({ subtitleCompared, setSubtitleCompared }) => {
    const intl = useIntl();
    const { defaultCustomer } = useAuth();
    const customerName = defaultCustomer.toLowerCase();
    const axiosPrivate = useAxiosPrivate();
    const surveyId = new URLSearchParams(window.location.search).get('survey');
    const {
        surveySubtitleColor
    } = useContext(StylesContext);
    const [surveySubtitle, setSurveySubtitle] = React.useState("")

    const autoGrow = (element) => {
        element.style.height = "5px";
        element.style.height = (element.scrollHeight) + "px";
    };
    const handleSubTitleChange = (e) => {
        setSurveySubtitle(e.target.value);
        autoGrow(e.target);
    }
    const { data: surveySettings, isLoading: isLoadingSurveySettings } = useQuery({
        queryKey: ["surveySettings", surveyId], //Si cambio esto cambiar la linea 100~ de saveChangesViewSurvey
        queryFn: async () => {
            const response = await axiosPrivate.get(`surveySettings/survey/${surveyId}?customer=${customerName}`);
            setSubtitleCompared(response.data.survey_subtitle);
            return response.data
        },
        refetchOnWindowFocus: false,
        retry: 0,
    });
    
    useEffect(() => {
        if (surveySettings) {
            if (surveySettings.survey_subtitle === '') {
                setSurveySubtitle(intl.formatMessage({ id: "styles.change.subtitle" }));
            } else {
                setSurveySubtitle(surveySettings.survey_subtitle);
            }
        } else {
            setSurveySubtitle(intl.formatMessage({ id: "styles.change.subtitle" }));
        }
        //eslint-disable-next-line
    }, [surveySettings]);

    return (
        <>
            <h5 className='text-center RegularMadeTommy'>
                <b>
                    <CreateIcon /> <FormattedMessage
                        id="styles.click.to.change.title"
                    />
                </b>
            </h5>
            {isLoadingSurveySettings ?
                <LoadingDots
                    text={
                        <FormattedMessage
                            id="loading.msg"
                            defaultMessage={'Cargando'}
                        />
                    }
                    dotCount={3}
                    color="black"
                />
                :
                <h5 className="reduceTitle mt-3">
                    <textarea
                        id="input-subtitle"
                        className='titleInputSmall text-center RegularMadeTommy'
                        type="text"
                        style={{ color: surveySubtitleColor }}
                        maxLength={200}
                        spellCheck="false"
                        value={surveySubtitle}
                        onChange={handleSubTitleChange}
                    />
                </h5>}
        </>
    )
}
